'use strict';

angular.module('web2print.recipients')
  .filter('nodeFilter', function () {
    function fuzzysearch (needle, haystack) {
      const hlen = haystack.length;
      const nlen = needle.length;
      if (nlen > hlen) {
        return false;
      }
      if (nlen === hlen) {
        return needle === haystack;
      }
      outer: for (let i = 0, j = 0; i < nlen; i++) {
        const nch = needle.charCodeAt(i);
        while (j < hlen) {
          if (haystack.charCodeAt(j++) === nch) {
            continue outer;
          }
        }
        return false;
      }
      return true;
    }

    return function (collection, property, search, minLength) {
      minLength = minLength || 0;

      if (angular.isUndefined(property) || angular.isUndefined(search) || minLength >= search.length) {
        return collection;
      }

      search = search.toLowerCase();

      return collection.filter(function f (node) {
        let prop = node[property];

        // skip if the property doesn't exist
        if (angular.isUndefined(prop)) {
          return false;
        }

        prop = prop.toLowerCase();

        // check if our term matches the items property
        if (fuzzysearch(search, prop)) {
          return true;
        }

        // check and see if any of the children match the search term
        if (node.children) {
          return node.children.filter(f).length;
        }

        // there is nothing that matches this node
        return false;
      });
    };
  });
